/* import __COLOCATED_TEMPLATE__ from './dropdown-with-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import Component from '@glimmer/component';

export interface Args {
  item: {
    text: string;
    value: string;
    componentAttrs: {
      text: string;
      hasTooltip: boolean;
    };
  };
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class DropdownWithTooltip extends Component<Signature> {
  @service declare intl: IntlService;

  get tooltipText() {
    return this.intl.t(
      `standalone.salesforce.setup.article-sync.steps.map.dropdown-tooltip.${this.args.item.componentAttrs.text}`,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::SalesforceArticleSync::Steps::DropdownWithTooltip': typeof DropdownWithTooltip;
    'knowledge-hub/salesforce-article-sync/steps/dropdown-with-tooltip': typeof DropdownWithTooltip;
  }
}
